import * as React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import * as moment from 'moment-timezone';
import * as api from '@crochik/schedulerapi.ts';
import App from '@crochik/pi-react/application/App';
import { Default } from '@crochik/pi-react/context';
import { CustomPage } from '@crochik/pi-react/application/Page';

import API from '../services/API';
import { AppointmentFormState } from '../AppointmentForm';
import Appointment from './comps/Appointment';
import { CircularProgress } from '@material-ui/core';

interface State {
    date?: string;
    time?: string;
    busy: boolean;
}

@observer
class AppointmentPage extends React.Component<{}, State> {
    constructor(props: any) {
        super(props);

        var date = Default.state.get('start', 'form.Appointment');
        if (date && date instanceof Date) {
            var mStart = moment(date);
            this.state = {
                date: mStart.format('ddd, MM/DD'),
                time: mStart.format('hh:mm A'),
                busy: false,
            };
        } else {
            this.state = {
                busy: false,
            };
        }
    }

    @action
    selectSchedulePage = () => {
        Default.actions.execute('show', 'page.Calendar');
    }

    createAppointment = async () => {
        const form: AppointmentFormState = Default.state.get('Appointment', 'form');
        const { start, end } = form;
        const request: api.AppointmentReq = {
            start,
            end,
        };

        this.setState({ busy: true });

        API().createAppointment(request)
            .then(appt => {
                App().selectPage('Confirmation', 'Submit', appt);
            })
            .catch(e => {
                alert('Error adding appointment');
                this.setState({ busy: false });
            });
    }

    render() {
        const { busy, date, time } = this.state;

        if (busy) {
            return (
                <div className="pi-content pi-form">
                    <div className="pi-progress"><CircularProgress size={100} color="primary" /></div>
                </div>
            );
        }
        
        return (
            <div className="pi-content pi-form">
                <Appointment
                    onClick={this.selectSchedulePage}
                    onCreateAppointment={this.createAppointment}
                    date={date}
                    time={time}
                />
            </div>
        );
    }
}

export default (name: string, title: string) => new CustomPage({ name, label: title }, <AppointmentPage />);


// WEBPACK FOOTER //
// ./src/app/pages/Appointment.tsx